module.exports = __webpack_public_path__ + "img/picture_ksdeb.bc142840.png";